import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=ccba117c&scoped=true&"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&id=ccba117c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccba117c",
  null
  
)

export default component.exports